<div class="inquiry-card" *ngIf="!!item">
  <!-- Card Header -->
  <div class="card-header">
    <h3 class="service-title" *ngIf="item.service == inquiryServiceType.CLEAN">
      <i class="fas fa-broom service-icon"></i>
      REINIGUNGSANFRAGE
    </h3>
    <h3 class="service-title" *ngIf="item.service != inquiryServiceType.CLEAN">
      <i class="fas fa-truck service-icon"></i>
      UMZUGSANFRAGE
    </h3>
    <p class="service-date" *ngIf="item.service == inquiryServiceType.CLEAN">
      {{item.cleaning_date | date: 'dd. MMMM yyyy'}}
    </p>
    <p class="service-date" *ngIf="item.service != inquiryServiceType.CLEAN">
      {{item.moving_date | date: 'dd. MMMM yyyy'}}
    </p>
  </div>

  <!-- Location Section -->
  <div class="location-section">
    <!-- Moving service with from/to locations -->
    <div *ngIf="item.service != inquiryServiceType.CLEAN" class="location-grid">
      <div class="location-card clickable" (click)="openGoogleMaps(item.from_zip + ' ' + item.from_location)">
        <div class="location-header">
          <i class="fas fa-map-marker-alt location-icon"></i>
          <div class="location-label">Von</div>
        </div>
        <p class="location-text">{{item.from_zip}} {{item.from_location}}</p>
      </div>
      <div class="location-card clickable" (click)="openGoogleMaps(item.to_zip + ' ' + item.to_location)">
        <div class="location-header">
          <i class="fas fa-map-marker-alt location-icon"></i>
          <div class="location-label">Nach</div>
        </div>
        <p class="location-text">{{item.to_zip}} {{item.to_location}}</p>
      </div>
    </div>

    <!-- Cleaning service with single location -->
    <div *ngIf="item.service == inquiryServiceType.CLEAN" class="single-location clickable" (click)="openGoogleMaps(item.from_zip + ' ' + item.from_location)">
      <div class="location-header">
        <i class="fas fa-map-marker-alt location-icon"></i>
        <div class="location-label">Objekt in</div>
      </div>
      <p class="location-text">{{item.from_zip}} {{item.from_location}}</p>
      <div class="map-hint">
        <i class="fas fa-external-link-alt"></i>
        <span>In Maps öffnen</span>
      </div>
    </div>
  </div>

  <!-- Property Details -->
  <div class="property-details">
    <div class="details-grid">
      <div class="detail-item">
        <div class="detail-label">Art</div>
        <p class="detail-value">{{item.from_type | propertyTypePipe}}</p>
      </div>
      <div class="detail-item">
        <div class="detail-label">Zimmer</div>
        <p class="detail-value">{{item.from_size_rooms}}</p>
      </div>
      <div class="detail-item">
        <div class="detail-label">m²</div>
        <p class="detail-value">{{item.from_size_square_meters | sizeSquareTypePipe}}</p>
      </div>
      <div class="detail-item">
        <div class="detail-label">Lift</div>
        <p class="detail-value">{{item.from_type_of_elevator}} Pers.</p>
      </div>
      <div class="detail-item">
        <div class="detail-label">Möbelstücke</div>
        <p class="detail-value">{{numberOfFurniture}}</p>
      </div>
    </div>
  </div>

  <!-- Extras Section -->
  <div class="extras-section">
    <h4 class="extras-title">Extras</h4>
    <div class="extras-grid" *ngIf="hasAnyExtras(); else noExtras">
      <ng-container *ngFor="let service of services">
        <span class="extra-tag" *ngIf="hasService(service)">
          {{serviceName(service)}}
        </span>
      </ng-container>
    </div>
    <ng-template #noExtras>
      <div class="no-extras">
        <i class="fas fa-minus-circle no-extras-icon"></i>
        <span class="no-extras-text">Keine Extras gewählt</span>
      </div>
    </ng-template>
  </div>

  <!-- Card Footer -->
  <div class="card-footer">
    <a [routerLink]="[]" class="details-button" (click)="navigateToDetails()">
      Details ansehen
    </a>
  </div>
</div>

<!-- <pre *ngIf="environment.envName == 'local_dev'" style="font-size: 10px; margin-top: 20px; opacity: 0.5;">{{item | json}}</pre> -->
